import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';

import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { getSimpleVenuesTemplates } from '@go-client/lib/api/venueTemplate';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';

export const DayTemplateVenueDataLog: React.FC<UserActionLog> = ({ body, url }) => {
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        let fields = {};

        const urlParts = url!.split('/');
        const venueId = urlParts[4];
        if (venueId) {
          const venues = await getSimpleVenuesTemplates();
          const venue = venues.find(v => v._id === venueId);
          if (venue) {
            const propertyFields = FieldsReplacer(venue, logFields, [
              {
                from: 'name',
                to: 'template',
              },
            ]);

            fields = { ...fields, ...propertyFields };
          }
        }

        setLogFields({ ...logFields, ...fields });
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
